export default {
  // 节假日展示
  holidayCalendarShow: "/settings/holidayCalendar/show",
  // 新增节假日
  holidayCalendarAdd: "/settings/holidayCalendar/add",
  // 根据id删除节假日数据
  holidayCalendarDelete: "/settings/holidayCalendar/delete",
  // 修改节假日
  holidayCalendarUpdate: "/settings/holidayCalendar/update",
  // 在页面上直接修改支付状态
  holidayCalendarQuickPaid: "/settings/holidayCalendar/quickPaid",
};
